import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { useSelector } from "react-redux";
import { updateARN } from "./service";

const firebaseConfig = {
  apiKey: "AIzaSyCRMAlf6SqdSkaVuvPFOoz8O4Pb7oPjLKA",
  authDomain: "ghoshak-991ff.firebaseapp.com",
  databaseURL: "https://ghoshak-991ff.firebaseio.com",
  projectId: "ghoshak-991ff",
  storageBucket: "ghoshak-991ff.appspot.com",
  messagingSenderId: "306673479060",
  appId: "1:306673479060:web:e939e0c8730de7f23af381",
};

initializeApp(firebaseConfig);
const messaging = getMessaging();

export const RequestForToken = async () => {
  const shopDetails = useSelector((state) => state.shopDetails);

  const getShopDetailsApi = async (id, currentToken) => {
    let token = shopDetails.userEndpointARN;
    if (typeof token == "string") {
      var newTokenStructure = {
        mobileTokens: [token],
        webTokens: [currentToken],
      };
      await updateARN(newTokenStructure, shopDetails.shopId);
    } else if (typeof token === "object") {
      if (!token.webTokens?.includes(currentToken)) {
        token.webTokens?.push(currentToken);
        await updateARN(token, shopDetails.shopId);
      }
    }
  };

  return getToken(messaging, {
    vapidKey:
      "BBmerUjzQMFBmj-rFqs-bVtu2orWD4hVA-8_e_xF0brabOtjI7QYvB3KEhmVp5mzCnpRO2KHxLQcSfTAPG_eK_w",
  })
    .then((currentToken) => {
      console.log("currentToken", currentToken);
      if (currentToken) {
        // setCurrentDeviceToken(currentToken);
        getShopDetailsApi(shopDetails.shopId, currentToken);
      } else {
        // Show permission request UI
        console.error(
          "No registration token available. Request permission to generate one."
        );
      }
    })
    .catch((err) => {
      console.error("An error occurred while retrieving token. ", err);
    });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("payload", payload);
      resolve(payload);
    });
  });
